import { Navigate } from "react-router-dom";
import Breakdown from "./Components/Breakdown/Breakdown";
import { TeamSettings } from "./Components/Settings/TeamSettings";
import { Baseline } from "./Components/Baseline/Baseline";
import { OnBoarding } from "./Components/OnBoarding";
import { Compare } from "./Components/Compare/Compare";
import { Drills } from "./Components/Drills/Drills";
import { WeeklyBuckets } from "./Components/WeeklyBuckets/WeeklyBuckets";
import { Features } from "./Components/MarketingPages/Features";
import { About } from "./Components/MarketingPages/About";
import { Team } from "./Components/MarketingPages/Team";
import { Customers } from "./Components/MarketingPages/Customers";
import OnBoard from "./Components/Onboarding/OnBoard";
import DashboardAltPage from "./Components/DashboardAlt/DashboardAltPage";

import Main from "./sections/Hero";
import { Home } from "./views";
import { BlogDetail } from "./sections/Blogs/BlogDetail";
import BlogPost from "./sections/Blogs/BlogPost";
import { Login } from "./Components/Login"

import { GeneralReports } from "./Components/Report/GeneralReports.tsx";
import { HealthPage } from "./Components/Health/HealthPage";


export const CHATBOT_PATH = "/chatbot";

// Public/marketing pages (exact pathnames, trailing slash stripped by consumers).
// Lives here, next to ROUTES, so adding a marketing page means editing one file.
// Exact matches on purpose: "/team" as a prefix would wrongly cover /teamdata.
export const PUBLIC_PATHS = [
  "/",
  "/login",
  "/features",
  "/about",
  "/team",
  "/customer-success",
  "/blog-detail",
  "/maximizing-performance-georgia-tech-football",
];

export const ROUTES = [
  // { path: '/postdata', component:  PostData},
  // { path: '/teamdata', component:  TeamData},
  // { path: '/playerdata', component: PlayerData},
  { path: "/sandbox", element: <DashboardAltPage /> },

  { path: "/breakdown/:date?", element: <Breakdown /> },
  { path: "/baseline", element: <Baseline /> },
  { path: "/compare", element: <Compare /> },
  { path: "/drills", element: <Drills /> },
  { path: "/weekly-buckets", element: <WeeklyBuckets /> },
  { path: "/settings", element: <Navigate to="/settings/overview" replace /> },
  { path: "/settings/:tab", element: <TeamSettings /> },
  { path: "/settings/treatment-log", element: <Navigate to="/health/treatment-log" replace /> },
  { path: "/settings/health-injuries", element: <Navigate to="/health/injuries" replace /> },
  { path: "/health/:tab?", element: <HealthPage /> },
  { path: "/reports", element: <GeneralReports /> },
  // { path: '/onboard', element: <OnBoard},
  // { path: '/login', element:Login},
  // { path: '/overview', element:Overview},
  { path: "/features", element: <Features /> },
  { path: "/about", element: <About /> },
  { path: "/team", element: <Team /> },
  { path: "/customer-success", element: <Customers /> },
  { path: "/on", element: <OnBoarding /> },
  { path: "/blog-detail", element: <BlogDetail /> },
  { path: "/", element: <Login/> },
  {
    path: "/maximizing-performance-georgia-tech-football",
    element: (
      <BlogPost article="https://docs.google.com/document/d/e/2PACX-1vTZRK08DqVh-fJwGme0dZItPf_fjuum0WIsuXv0hVgzmlJcc8IxhFkkOCE7nEWnLsNP6rqRB2psm76q/pub?embedded=true" />
    ),
  },
];
